export const signup_style = {
  rootSx: {
    backgroundColor: '#F3F0FF',
    height: '100vh',
  },
  imgContSx: {
    py: 3.5,
  },
};
